export default {
    data() {
        return {
            zoomBy: 100,
        }
    },
    created() {
        if (!this.meta.isText){
            this.allPages = this.allPages.map(this.preparePage)
        }
    },
    methods: {
        increaseZoom() {
            if (this.zoomBy >= 300){
                return
            }
            const oldSelectedDictionary = this.selectedDictionary
            this.zoomBy += 20
            this.$nextTick(() => {
                if (oldSelectedDictionary){
                    this.setPage(oldSelectedDictionary.id)
                }
            })
        },
        decreaseZoom() {
            if (this.zoomBy <= 100){
                return
            }
            const oldSelectedDictionary = this.selectedDictionary
            this.zoomBy -= 20
            this.$nextTick(() => {
                if (oldSelectedDictionary){
                    this.setPage(oldSelectedDictionary.id)
                }
            })
        },
        preparePage(p) {
            const contentEl = document.createElement('div')

            contentEl.classList.add('absolute', 'inset-0', 'overflow-hidden', 'w-full')
            p.json_text.paragraphs.forEach((paragraph, index) => {
                const previous = index-1 in p.json_text.paragraphs ? p.json_text.paragraphs[index-1] : null
                const next = index+1 in p.json_text.paragraphs ? p.json_text.paragraphs[index+1] : null
                contentEl.appendChild(this.buildParagraph(paragraph, p, previous, next))
            })

            p.content = contentEl.outerHTML

            return p
        },
        buildParagraph(paragraph, p, previousParagraph, nextParagraph) {
            const paragraphEl = document.createElement('div')
            let [pWidth, pHeight] = p.json_text.size
            let [left, top, right, bottom] = paragraph.bbox

            const pageRatio = pHeight / pWidth;
            paragraphEl.style.lineHeight = `0`
            paragraphEl.style.wordSpacing = `0`
            paragraphEl.style.letterSpacing = `0`
            paragraphEl.style.height = `${((bottom - top) / pHeight) * 100}%`;
            paragraphEl.style.width = `${((right - left) / pWidth) * 100}%`;
            paragraphEl.style.marginTop = `${((top - (previousParagraph ? previousParagraph.bbox[3] :  0)) / pHeight) * pageRatio * 100}%`;
            paragraphEl.style.marginLeft = `calc(${(left / pWidth) * 100}%)`;
            paragraphEl.style.marginRight = `calc(${((pWidth - right) / pWidth) * 100}%`;

            paragraph.lines.forEach((line, index) => {
                const previous = index-1 in paragraph.lines ? paragraph.lines[index-1] : null
                const next = index+1 in paragraph.lines ? paragraph.lines[index+1] : null
                paragraphEl.appendChild(this.buildLine(line, paragraph, p, previous, next))

            })

            return paragraphEl
        },
        buildLine(line, paragraph, p, previousLine, nextLine){
            const lineEl = document.createElement('div')
            lineEl.classList.add('flex')
            let [left, top, right, bottom] = line.bbox
            let [paragraphLeft, paragraphTop, paragraphRight, paragraphBottom] = paragraph.bbox
            const paragraphHeight = paragraphBottom - paragraphTop;
            const paragraphWidth = paragraphRight - paragraphLeft;
            const paragraphRatio = paragraphHeight / paragraphWidth;
            lineEl.style.height = `${((bottom - top) / paragraphHeight) * 100}%`;
            lineEl.style.width = `${((right - left) / paragraphWidth) * 100}%`;
            lineEl.style.marginTop = `${((top - paragraphTop - (previousLine ? previousLine.bbox[3] - paragraphTop : 0)) / paragraphHeight) * paragraphRatio * 100}%`;
            lineEl.style.marginLeft = `${((left - paragraphLeft) / paragraphWidth) * 100}%`;
            lineEl.style.marginRight = `${((paragraphWidth - (right - paragraphLeft)) / paragraphWidth) * 100}%`;

            line.words.forEach((word, index) => {
                const previous = index - 1 in line.words ? line.words[index - 1] : null
                const next = index + 1 in line.words ? line.words[index + 1] : null
                lineEl.appendChild(this.buildWord(word, line, paragraph, p, previous, next, previousLine))
            })

            return lineEl
        },
        buildWord(word, line, paragraph, p, previousWord, nextWord, previousLine){
            const wordEl = document.createElement('span')
            wordEl.classList.add('inline-block', 'text-transparent', 'flex', 'items-center', 'cursor-text', 'overflow-hidden', 'h-full', 'text-3xl')

            let [lineLeft, lineTop, lineRight, lineBottom] = line.bbox
            let [left, top, right, bottom] = word.bbox

            wordEl.textContent = word.suggestions ? '_'.repeat(word.text) : word.text

            const lineWidth = lineRight - lineLeft;
            const marginRight = () => {
                if (!previousWord) {
                    return ((lineRight - right) / lineWidth) * 100;
                } else if ((previousWord ? previousWord.bbox[0] - lineLeft : 0) <= 0) {
                    return 0;
                }
                return (
                    (((previousWord ? previousWord.bbox[0] - lineLeft : 0) - (right - lineLeft)) / lineWidth) * 100
                );
            };
            wordEl.id = `word_${word.id.split("_")[1]}_${word.id.split("_")[4]}`;
            wordEl.dataset.fullId = word.id;
            wordEl.dataset.isWord = true;
            wordEl.style.width = `${((right - ((nextWord ? nextWord.bbox[2] : left))) / lineWidth) * 100}%`;

            return wordEl
        }
    }
}
